import getBase64 from "./getBase64"

export default getBase64
